import { Minimize2 } from 'lucide-react';
import type { ReactElement } from 'react';

export interface CanvasFullscreenExitButtonProps {
  visible: boolean;
  onExit: () => void;
}

/** Fixed bottom-right control to leave full-page engage mode. */
export function CanvasFullscreenExitButton({
  visible,
  onExit,
}: CanvasFullscreenExitButtonProps): ReactElement | null {
  if (!visible) return null;

  return (
    <div className="absolute bottom-3 right-3 z-[200] pointer-events-auto">
      <button
        type="button"
        onClick={() => {
          void onExit();
        }}
        aria-label="Exit full-page canvas"
        title="Exit full page"
        className="p-2.5 rounded-xl bg-canvas-surface border border-canvas-border text-canvas-muted hover:text-canvas-primary hover:border-canvas-primary/40 hover:bg-canvas-surface-subtle transition-colors shadow-sm"
      >
        <Minimize2 size={18} strokeWidth={1.75} />
      </button>
    </div>
  );
}
